import { useLocation } from "react-router-dom";

import { prototypes } from "../../../config/prototypes";

export const useCurrentPrototype = () => {
  const location = useLocation();
  const currentPrototype = prototypes.find((p) => p.path === location.pathname);
  return currentPrototype;
};
